import {AxiosCall} from '../axios';

export const getAllCustomTemplates = async (
  clinic_group_id: string | number,
  clinic_id: string | number
): Promise<any> => {
  const ulr = `/custom-message-templates?clinic_group_id=${
    clinic_group_id || ''
  }&clinic_id=${clinic_id || ''}`;

  return AxiosCall.get(ulr);
};
